<script setup lang="ts">
/**
 * UI-kit component
 * Category: Filters
 * Name: FiltersBar
 */
import type { FiltersBarProps } from '../types/interfaces'

import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'

import { useFiltersBar } from '../composables/filters-bar.hook'

defineOptions({
  name: 'FiltersBar',
})

const props = withDefaults(defineProps<FiltersBarProps>(), {
  loading: false,
  clearable: true,
})

const emit = defineEmits<{
  'click:submit': []
  'click:clear': []
}>()

const { handleFieldsEnter } = useFiltersBar({
  props,
  onSubmit: () => emit('click:submit'),
})
</script>

<template>
  <div class="filters-bar">
    <div
      class="filters-bar__fields"
      @keydown.enter.capture="handleFieldsEnter"
    >
      <slot name="fields" />
    </div>

    <div class="filters-bar__controls">
      <BtnIcon
        v-if="clearable"
        :icon="faFilterCircleXmark"
        color="red"
        tooltip-text="Clear filters"
        :disabled="loading"
        @click="emit('click:clear')"
      />
      <BtnPrimary
        text="Search"
        element-width="auto"
        :disabled="loading"
        @click="emit('click:submit')"
      />
      <slot name="end" />
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_filters-bar.scss" />
